<template>
    <span
        :class="{
            icon: true,
            [`icon--${size}`]: !customSize,
            [`icon-${code.replaceAll('/', '-')}`]: true,
        }"
        :style="{
            width: customSize,
            height: customSize,
        }"
        :aria-label="alt || `${$t('dsIcon.icon')} ${code}`"
        v-html="icon ?? ''"
    />
</template>
<script>
import { computed, ref, watch } from 'vue';
import { mapKeys } from 'lodash-es';

const iconImports = mapKeys(
    import.meta.glob('../../assets/icon/**/*.svg', { query: '?raw', import: 'default' }),
    (_, path) => path.substring('../../assets/icon/'.length, path.length - '.svg'.length),
);

export const iconCodes = Object.keys(iconImports);
</script>
<script setup>
const props = defineProps({
    alt: {
        type: String,
        default: '',
    },
    code: {
        type: [String, null],
        default: '',
    },
    size: {
        type: String,
        default: 'm',
    },
});

const customSize = computed(() => (props.size.match(/[\d\\.]+/) || {}).input);

const loadIcon = code => iconImports[code] ? iconImports[code]() : null;

const icon = ref(await loadIcon(props.code));
watch(() => props.code, async code => {
    icon.value = null;
    icon.value = await loadIcon(code);
});
</script>

<style scoped>
.icon {
  display: inline-flex;
  place-items: center;
  line-height: 1;
}
.icon--xxs {
  width: 0.5rem;
  height: 0.5rem;
}
.icon--xs {
  width: 1rem;
  height: 1rem;
}
.icon--s {
  width: 1.125rem;
  height: 1.125rem;
}
.icon--m {
  width: 1.25rem;
  height: 1.25rem;
}
.icon--l {
  width: 1.5rem;
  height: 1.5rem;
}
.icon--xl {
  width: 1.75rem;
  height: 1.75rem;
}
.icon--xxl {
  width: 2rem;
  height: 2rem;
}
.icon--xxxl {
  width: 2.5rem;
  height: 2.5rem;
}
.icon--xxxxl {
  width: 4rem;
  height: 4rem;
}
.icon :deep(svg) {
  max-width: 100%;
  width: 100%;
  height: auto;
}
.icon:not([class*=icon-flags-]) :deep(svg) {
  fill: currentcolor;
}
</style>
